import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useColorScheme } from '@mui/material/styles';
import { isDarkAppBar } from '../theme/brandTheme';
import { useBrandTheme } from '../theme/BrandThemeContext';
import { useBrand } from '../theme/useBrand';

/**
 * The brand's logo for the app bar's tone in the active scheme (reversed on a dark bar, handoff
 * §3.5), else its short-name wordmark (CNPWKS-0007 C11, CNPWKS-0011 P5).
 */
export function BrandMark() {
  const { logo, logoReversed, productName, shortName } = useBrand();
  const { colorScheme } = useColorScheme();
  const { brandTheme } = useBrandTheme();
  const mode = (colorScheme ?? 'light') === 'dark' ? 'dark' : 'light';
  const url = isDarkAppBar(brandTheme.modes[mode]) ? logoReversed : logo;

  if (url !== null) {
    return (
      <Box
        component="img"
        src={url}
        alt={productName}
        sx={{ height: (t) => t.spacing(4), width: 'auto', display: 'block' }}
      />
    );
  }
  return (
    <Typography variant="body2" component="p" sx={{ fontWeight: 'fontWeightMedium' }}>
      {shortName}
    </Typography>
  );
}
